export default __webpack_public_path__ + "static/media/Interactive Map.163f945f.svg";